var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('InputField',{attrs:{"type":"text","field":_vm.fakeField},model:{value:(_vm.$v.value.$model),callback:function ($$v) {_vm.$set(_vm.$v.value, "$model", $$v)},expression:"$v.value.$model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }